import { useTranslation } from '../../../../../utils/useTranslation';
import { IconStatistic } from '../../../../icon/IconStatistic';
import { TitleFlex, TitleIcon, TitleTypography } from './styles';

export const ContentPromotionTitle: React.FC<{}> = () => {
    const t = useTranslation();

    return (
        <TitleFlex pb={2}>
            <TitleIcon>
                <IconStatistic fontSize={24} margin="auto" height="100%" />
            </TitleIcon>
            <TitleTypography variant="title3" weight="bold">
                {t('Продвижение контента')}
            </TitleTypography>
        </TitleFlex>
    );
};
